import { Component, Input } from '@angular/core';

export interface Testimonial {
  name: string;
  position: string;
  quote: string;
  image: string;
  logo: string;
}

@Component({
  selector: 'app-champions-testimonial',
  standalone: false,
  templateUrl: './champions-testimonial.component.html',
  styleUrl: './champions-testimonial.component.scss'
})
export class ChampionsTestimonialComponent {
  @Input() testimonials: Testimonial[] = [];
  @Input() headingKey = 'home.testimonial.heading';
  @Input() subheadingKey = 'home.testimonial.subheading';

  currentTestimonialIndex = 0;

  nextTestimonial(): void {
    this.currentTestimonialIndex = (this.currentTestimonialIndex + 1) % this.testimonials.length;
  }

  previousTestimonial(): void {
    this.currentTestimonialIndex = (this.currentTestimonialIndex - 1 + this.testimonials.length) % this.testimonials.length;
  }

  get currentTestimonial(): Testimonial {
    return this.testimonials[this.currentTestimonialIndex];
  }

  get currentImage(): string {
    return this.currentTestimonial?.image || 'https://fdi-files.s3.amazonaws.com/public/userAvatar.jpg';
  }

  get currentLogo(): string {
    return this.currentTestimonial?.logo || 'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png';
  }

  get truncatedQuote(): string {
    const quote = this.currentTestimonial?.quote || '';
    if (quote.length <= 350) {
      return quote;
    }
    return quote.substring(0, 350) + '...';
  }
}
